import { Spacer, Typography } from '@capitalise/ui-design-system';
import PropTypes from 'prop-types';

const Toast = ({ icon, text }) => {
  const Icon = icon;
  return (
    <Spacer gap="tiny" alignItems="center">
      <Icon color="neutral-white" />{' '}
      <Typography size="body-14" color="white">
        {text}
      </Typography>
    </Spacer>
  );
};

Toast.propTypes = {
  icon: PropTypes.any,
  text: PropTypes.string,
};

export default Toast;
